import classNames from 'classnames';
import React from 'react';
import * as styles from './FieldSet.module.scss';

interface FieldSetProps {
  children?: React.ReactNode;
  legend?: React.ReactNode;
  margin?: 'none' | 'normal';
}

const FieldSet = ({ legend, children, margin = 'normal' }: FieldSetProps) => (
  <fieldset
    className={classNames(styles.fieldSet, {
      [styles.marginNormal]: margin === 'normal',
    })}
  >
    {!!legend && <legend className={styles.legend}>{legend}</legend>}
    {children}
  </fieldset>
);

export default FieldSet;
